export default __webpack_public_path__ + "static/media/vip11-bg.98c92402.webp";